import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

// noinspection AngularMissingOrInvalidDeclarationInModule
@Component({
    template: '',
    standalone: false
})
export abstract class BwsBaseComponent implements OnDestroy {

  public destroySubject: Subject<void> = new Subject<void>();

  public ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

}
